import React, { useEffect, useState } from "react";
import Select from "react-select";
import Modal from "../common/Modal";
import { createSellerOffer } from "../../utils/api";

import {
    getMaterialList,
    getMaterialLocationList,
    getPolymerList,
    getPackagingBagList,
    getSellerId
} from "../../utils/api";

const AddOfferModal = ({ open, onClose, onSubmit }) => {

    const [form, setForm] = useState({
        material: null,
        location: null,
        qty: "",
        price: "",
        polymer: null,
        packaging: null
    });

    const [options, setOptions] = useState({
        materials: [],
        locations: [],
        polymers: [],
        packaging: []
    });

    const seller = getSellerId();

    useEffect(() => {
        if (!open) return;

        loadInitialData();

    }, [open]);

    const loadInitialData = async () => {
        try {
            const [polymerRes, packagingRes] = await Promise.all([
                getPolymerList(),
                getPackagingBagList()
            ]);

            setOptions(prev => ({
                ...prev,
                polymers: polymerRes?.data || [],
                packaging: packagingRes?.data || []
            }));

        } catch (err) {
            console.error("Load failed", err);
        }
    };

    // 🔍 Searchable material
    const loadMaterials = async (input) => {
        const res = await getMaterialList({
            seller_id: seller,
            search_text: input,
            page_number: 1,
            page_size: 10
        });

        setOptions(prev => ({
            ...prev,
            materials: res?.data || []
        }));
    };

    // 🔍 Searchable location
    const loadLocations = async (input) => {
        const res = await getMaterialLocationList({
            search_text: input,
            page_number: 1,
            page_size: 10
        });

        setOptions(prev => ({
            ...prev,
            locations: res?.data || []
        }));
    };

    const handleSubmit = async () => {
        try {

            if (!form.qty || !form.price) {
                alert("Quantity and Price are required");
                return;
            }

            const payload = {
                seller_id: seller,

                grade_id: form.material?.grade_id,
                process_type_id: form.material?.process_id,
                brand_id: form.material?.brand_id,
                grade_code_id: form.material?.grade_code_id,

                polymer_id: form.polymer,
                packaging_bag_id: form.packaging,

                qty: Number(form.qty),
                original_price: Number(form.price),

                area_id: form.location?.area_id
            };

            console.log("Submitting:", payload);
            console.log("FORM:", form);
            console.log("PAYLOAD:", payload);

            await createSellerOffer(payload);

            onSubmit(payload); // refresh table
            onClose();

        } catch (err) {
            console.error("Create offer failed", err);
            alert("Failed to create offer");
        }
    };

    const safeLabel = (m) =>
        [m?.process_name, m?.brand_name, m?.code_name]
            .filter(Boolean)
            .join(" ");

    return (
        <Modal open={open} title="Add New Offer" onClose={onClose}>

            <div className="offer-form">

                {/* Row 1 */}
                <div className="form-row">
                    <div className="form-group">
                        <label>Material</label>
                        <Select
                            classNamePrefix="rs"
                            placeholder="Search material..."
                            onInputChange={(value) => {
                                if (typeof value === "string") {
                                    loadMaterials(value);
                                }
                            }}
                            options={(options.materials || []).map(m => ({
                                value: m.id,
                                label: String(
                                    [m?.process_name, m?.brand_name, m?.code_name]
                                        .filter(v => typeof v === "string")
                                        .join(" ")
                                ) || "Unnamed Material"
                            }))}
                            onChange={(val) =>
                                setForm(prev => ({
                                    ...prev,
                                    material: val
                                        ? options.materials.find(m => m.id === val.value)
                                        : null
                                }))
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label>Location</label>
                        <Select
                            classNamePrefix="rs"
                            placeholder="Search location..."
                            onInputChange={(value, meta) => {
                                if (meta.action === "input-change" && typeof value === "string") {
                                    loadLocations(value);
                                }
                            }}
                            options={(options.locations || []).map(l => ({
                                value: l.id,
                                label: typeof l?.name === "string" ? l.name : "Unknown Location"
                            }))}
                            filterOption={null}
                            onChange={(val) =>
                                setForm(prev => ({
                                    ...prev,
                                    location: val
                                        ? options.locations.find(l => l.id === val.value)
                                        : null
                                }))
                            }
                        />
                    </div>
                </div>

                {/* Row 2 */}
                <div className="form-row">
                    <div className="form-group">
                        <label>Quantity (MT)</label>
                        <input
                            type="number"
                            placeholder="Enter quantity"
                            value={form.qty}
                            onChange={(e) =>
                                setForm(prev => ({ ...prev, qty: e.target.value }))
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label>Price (₹/kg)</label>
                        <input
                            type="number"
                            step="0.05"
                            placeholder="Enter price"
                            value={form.price}
                            onChange={(e) =>
                                setForm(prev => ({ ...prev, price: e.target.value }))
                            }
                        />
                    </div>
                </div>

                {/* Polymer */}
                <div className="form-group">
                    <label>Polymer Quality</label>
                    <div className="chip-group">
                        {options.polymers.map(p => (
                            <div
                                key={p.id}
                                className={`chip ${form.polymer === p.id ? "active" : ""}`}
                                onClick={() =>
                                    setForm(prev => ({ ...prev, polymer: p.id }))
                                }
                            >
                                {p.name}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Packaging */}
                <div className="form-group">
                    <label>Packaging</label>
                    <div className="chip-group">
                        {options.packaging.map(p => (
                            <div
                                key={p.id}
                                className={`chip ${form.packaging === p.id ? "active" : ""}`}
                                onClick={() =>
                                    setForm(prev => ({ ...prev, packaging: p.id }))
                                }
                            >
                                {p.name}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Action */}
                <div className="form-actions">
                    <button className="btn-outline" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-primary" onClick={handleSubmit}>
                        Create Offer
                    </button>
                </div>

            </div>

        </Modal>
    );
};

export default AddOfferModal;